/* eslint-disable */
import { getLocale, trackMessageCall, experimentalMiddlewareLocaleSplitting, isServer, experimentalStaticLocale } from '../runtime.js';
/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

const en_cc_ex2 = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`#767676 grey on white is exactly 4.5:1 — the AA minimum for body text.`)
};

const es_cc_ex2 = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`El gris #767676 sobre blanco es exactamente 4.5:1 — el mínimo AA para texto de cuerpo.`)
};

const de_cc_ex2 = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`#767676 Grau auf Weiß ergibt exakt 4,5:1 — das AA-Minimum für Fließtext.`)
};

const nl_cc_ex2 = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Grijs #767676 op wit is precies 4,5:1 — het AA-minimum voor lopende tekst.`)
};

const fr_cc_ex2 = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Le gris #767676 sur blanc donne exactement 4,5:1 — le minimum AA pour le texte courant.`)
};

const it_cc_ex2 = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Il grigio #767676 su bianco è esattamente 4,5:1 — il minimo AA per il testo del corpo.`)
};

const pt_br2_cc_ex2 = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`O cinza #767676 sobre branco fica exatamente em 4,5:1 — o mínimo AA para texto de corpo.`)
};

const pt_cc_ex2 = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`O cinzento #767676 sobre branco é exatamente 4,5:1 — o mínimo AA para texto de corpo.`)
};

const ja_cc_ex2 = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`白地にグレー(#767676)はちょうど4.5:1 — 本文テキストのAA最低基準です。`)
};

const zh_cc_ex2 = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`灰色 #767676 配白色恰好为 4.5:1——正文文字的 AA 最低要求。`)
};

/**
* This function has been compiled by [Paraglide JS](https://inlang.com/m/gerre34r).
*
* - Changing this function will be over-written by the next build.
*
* - If you want to change the translations, you can either edit the source files e.g. `en.json`, or
* use another inlang app like [Fink](https://inlang.com/m/tdozzpar) or the [VSCode extension Sherlock](https://inlang.com/m/r7kp499g).
* 
* @param {{}} inputs
* @param {{ locale?: "en" | "es" | "de" | "nl" | "fr" | "it" | "pt-BR" | "pt" | "ja" | "zh" }} options
* @returns {LocalizedString}
*/
/* @__NO_SIDE_EFFECTS__ */
export const cc_ex2 = (inputs = {}, options = {}) => {
	if (experimentalMiddlewareLocaleSplitting && isServer === false) {
		return /** @type {any} */ (globalThis).__paraglide_ssr.cc_ex2(inputs) 
	}
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	trackMessageCall("cc_ex2", locale)
	if (locale === "en") return en_cc_ex2(inputs)
	if (locale === "es") return es_cc_ex2(inputs)
	if (locale === "de") return de_cc_ex2(inputs)
	if (locale === "nl") return nl_cc_ex2(inputs)
	if (locale === "fr") return fr_cc_ex2(inputs)
	if (locale === "it") return it_cc_ex2(inputs)
	if (locale === "pt-BR") return pt_br2_cc_ex2(inputs)
	if (locale === "pt") return pt_cc_ex2(inputs)
	if (locale === "ja") return ja_cc_ex2(inputs)
	return zh_cc_ex2(inputs)
};